import {
	Button,
	Checkbox,
	FormControlLabel,
	FormHelperText,
	Grid,
	Paper,
	Divider,
	Typography,
  styled,
} from '@mui/material';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useState } from 'react';
import * as utils from '../../util/bellplus-utils';
import routes from '../../constants/Routes';
import * as api from '../../util/apis';
import { ENV } from 'constants/Constants';
import img from '../../images/bgImg.jpg';
import userAvatar from '../../images/user-avatar.png';
import { Link, useNavigate } from 'react-router-dom';
import theme from 'theme';


const PREFIX = 'LoginNew'

const classes = {
  container: `${PREFIX}-container`,
  paperBox: `${PREFIX}-paperBox`,
  columnGrid: `${PREFIX}-columnGrid`,
  loginBoxChild: `${PREFIX}-loginBoxChild`,
  avatarIcon: `${PREFIX}-avatarIcon`,
  formField: `${PREFIX}-formField`,
  inputFields: `${PREFIX}-inputFields`,
  labelField: `${PREFIX}-labelField`,
  label: `${PREFIX}-label`,
  loginButtonGrid: `${PREFIX}-loginButtonGrid`,
  loginButton: `${PREFIX}-loginButton`,
  registerButton: `${PREFIX}-registerButton`,
  errorObj:`${PREFIX}-errorObj`
}

const Root = styled(Grid)(({ theme: Theme }) => ({
  [`& .${classes.container}`]: {
    height: '100vh',
    backgroundImage: `url(${img})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
      alignItems: 'center',
    },
  },

  [`& .${classes.paperBox}`]: {
    marginRight: '10vw',
    borderRadius: theme.spacing(2),
    width: '400px',
    height: '450px',

    backgroundColor: 'rgb(255, 255, 255, 0.4)',
    [theme.breakpoints.down('md')]: {
      marginRight: '0px',
    },
  },

  [`& .${classes.columnGrid}`]: {
    padding: theme.spacing(4),
  },

  [`& .${classes.loginBoxChild}`]: {
    paddingTop: theme.spacing(4),
  },
  [`& .${classes.avatarIcon}`]: {
    width: '54px',
    height: '57px',
    fontSize: '250',
    marginBottom: theme.spacing(2),
  },
  [`& .${classes.formField}`]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  [`& .${classes.inputFields}`]: {
    borderRadius: theme.spacing(1),
    border: 'none',
    width: '100%',
    height: '50px',
    marginTop: theme.spacing(1),
  },
  [`& .${classes.labelField}`]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  [`& .${classes.label}`]: {
    color: '#ffffff',
    fontSize: '15px',
  },
  [`& .${classes.loginButtonGrid}`]: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(1),
    height: '50px',
  },
  [`& .${classes.loginButton}`]: {
    minWidth: '100%',
    borderRadius: '10px',
  },
  [`& .${classes.registerButton}`]: {
    minWidth: '100%',
    borderRadius: '10px',
    backgroundColor: '#20850f',
  },
  [`& .${classes.errorObj}`]: {
    color:'#ffffff'
  },
}))

function LoginNew() {
	const navigate = useNavigate()
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [loginError, setLoginError] = useState('');
	const [remember, setRemember] = useState(false);
	useEffect(() => {
		if (utils.isAuthenticated()) {
			navigate(routes.ADVERTISEMENT_DETAILS.path);
		}
	}, []);
	const [errorObj, setErrorObj] = useState<any>({});

	const handleEmail = (e: any) => {
		setEmail(e.target.value);
		setLoginError('');
	};
	const handlePassword = (e: any) => {
		setPassword(e.target.value);
		setLoginError('');
	};
	const goToRegistrationpage = () => {
		navigate(routes.REGISTRATION.path);
	};
	const handleCheckbox = (e: any) => {
		setRemember(e.target.checked);
		setLoginError('');
	};
	const authenticate = async (e: any) => {
		e.preventDefault();

		if (email.trim() && password.trim() !== '') {
			setLoginError('');
			const userCredentils = { email: email, password: password };
			utils.setData('userCredentials', userCredentils);
			let res: any;
			try {
				res = await api.login(ENV.dev.loginUrl, {
					username: email,
					password: password,
					rememberMe: remember,
				});
				utils.setData('userDetails', res.data);
				if (res.data.data.needsPasswordUpdate === true) {
					navigate(routes.RESET_PASSWORD.path);
				} else {
					navigate(routes.DASHBOARD.path);
				}
			} catch (error) {
				setLoginError('Username or password is incorrect');
			}
		}
	};

	return <Root>
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-end"
            className={classes.container}>
            <Grid item>
                <Paper elevation={2} className={classes.paperBox}>
                    <Grid
                        container
                        className={classes.columnGrid}
                        direction="column"
                        justifyContent="flex-end">
                        <Grid
                            item
                            container
                            xs={12}
                            className={classes.loginBoxChild}
                            justifyContent="center">
                            <Grid item>
                                <img
                                    className={classes.avatarIcon}
                                    src={userAvatar}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className={classes.formField}>
                            <InputText
                                autoFocus
                                id="email"
                                className={classes.inputFields}
                                value={email}
                                placeholder="Username"
                                onChange={handleEmail}
                            />
                            {/* <FormHelperText error={true}>
                                {errorObj.username}
                            </FormHelperText> */}
                        </Grid>
                        <Grid item xs={12} className={classes.formField}>
                            <InputText
                                className={classes.inputFields}
                                value={password}
                                type={'password'}
                                id="password"
                                placeholder="Password"
                                onChange={handlePassword}
                            />
                            <FormHelperText error={true}>
                                {errorObj.password}
                            </FormHelperText>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            className={classes.labelField}
                            direction="row"
                            alignItems="center">
                            <Grid
                                item
                                xs={6}
                                style={{
                                    paddingTop: '5px',
                                }}>
                                <FormControlLabel
                                    className={classes.label}
                                    value="remember"
                                    control={
                                        <Checkbox
                                            className={classes.label}
                                            color="primary"
                                            onChange={handleCheckbox}
                                            checked={remember}
                                        />
                                    }
                                    label={
                                        <Typography
                                            align="left"
                                            className={classes.label}>
                                            RememberMe
                                        </Typography>
                                    }
                                    labelPlacement="end"
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Link to="/forgotpassword">
                                    <Typography
                                        align="right"
                                        className={classes.label}
                                        >
                                        Forgot Password?
                                    </Typography>
                                </Link>
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} direction="row">
                            <Grid item xs={12} className={classes.loginButtonGrid}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={authenticate}
                                    className={classes.loginButton}>
                                    {' '}
                                    LOGIN{' '}
                                </Button>
                            </Grid>
                            <Divider orientation="horizontal" variant="fullWidth" />
                            <Grid item xs={12} className={classes.loginButtonGrid}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    onClick={goToRegistrationpage}
                                    className={classes.registerButton}>
                                    {' '}
                                    REGISTER{' '}
                                </Button>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={classes.formField}>
                            {loginError !== '' && (
                                <Typography align="center" className={classes.errorObj}>
                                    {loginError}
                                </Typography>
                            )}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    </Root>;
}

export default LoginNew;

